import type { EventIncidentType, EventType } from "app/types/eventType";
import "./BasketballPhase.scss";
import BasketballPhaseDeadBall from "./components/BasketballPhaseDeadBall/BasketballPhaseDeadBall";
import BasketballPhaseLive from "./components/BasketballPhaseLive/BasketballPhaseLive";

function BasketballPhase(props: { eventData: EventType }) {
  const { eventData } = props;
  const eventIncidents: EventIncidentType[] = eventData["eventIncidents"];
  const eventPhase: string = eventIncidents[0]["eventPhase"];
  const quarterPhase: boolean = eventPhase.includes("QUARTER");
  const halfPhase: boolean = eventPhase.includes("HALF");
  const isOverTime: boolean = eventPhase.includes("OVER");
  if (halfPhase) {
    return (
      <BasketballPhaseLive
        eventIncidents={eventIncidents}
        eventPhase={eventPhase}
      />
    );
  }

  if (isOverTime) {
    return (
      <BasketballPhaseLive
        eventIncidents={eventIncidents}
        eventPhase={eventPhase}
      />
    );
  }

  return quarterPhase ? (
    <BasketballPhaseLive
      eventIncidents={eventIncidents}
      eventPhase={eventPhase}
    />
  ) : (
    <BasketballPhaseDeadBall
      eventIncidents={eventIncidents}
      eventPhase={eventPhase}
    />
  );
}
export default BasketballPhase;
